import { createContext, useState, useEffect } from "react";
import axios from "axios";
export const GlobalContext = createContext();

export const GlobalProvider = (props) => {
  //yerel çalışmada bu aktif olacak
  // const API_URL = "http://localhost:3000"; // Geliştirme adresi

  //online için bu aktif olacak
  const API_URL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_APIURL // Üretim adresi
      : "http://localhost:3000"; // Geliştirme adresi

  const raporTurleri = [
    {
      name: "Maden Kamulaştırması",
      img: "images/maden.jpg",
      desc: "Maden Sahası Kamulaştırması Raporlarınızı Kolayca Yazın",
      link: "/dosyabilgileri",
    },
    {
      name: "ENH Kamulaştırması",
      img: "images/enh.jpg",
      desc: "Enerji Nakil Hattı Kamulaştırması Raporlarınızı Kolayca Yazın",
      link: "/enhdosyabilgileri",
    },
    {
      name: "Karayolu Kamulaştırması",
      img: "images/karayolu.jpg",
      desc: "Karayolu Kamulaştırması Raporlarınızı Kolayca Yazın",
      link: "/kydosyabilgileri",
    },
    // {
    //   name: "Doğalgaz Kamulaştırması",
    //   img: "images/dogalgaz.jpg",
    //   desc: "Doğalgaz Kamulaştırması Raporlarınızı Kolayca Yazın",
    //   link: "/dogalgaz",
    // },
    {
      name: "Çoklu Arazi Degerlemesi",
      img: "images/coklu.jpg",
      desc: "Çok Parselli Dosyalara İlişkin Raporlarınızı Kolayca Yazın",
      link: "/cddosyabilgileri",
    },
  ];
  const davaKonuları = [
    { id: 1, name: "Kamulaştırma" },
    { id: 2, name: "Elatmanın Önlenmesi" },
    { id: 3, name: "Tapu İptali ve Tescil" },
    { id: 4, name: "Taşınmazların Kıymet Takdiri" },
    { id: 5, name: "Ortaklığın Giderilmesi" },
    { id: 6, name: "Vasiyetnamenin Tenfizi" },
    {id:7, name:"Tazminat"},
  ];
  const dosyaTurleri = [
    { id: 1, name: "Esas" },
    { id: 2, name: "Talimat" },
    { id: 3, name: "D. İş" },
    {id:4,name:"Sor."}
  ];
  const mahkemeTurleri = [
    { id: "1", name: "Asliye Hukuk Mahkemesi" },
    { id: "2", name: "Sulh Hukuk Mahkemesi" },
    { id: "3", name: "Asliye Ceza Mahkemesi" },
    { id: "4", name: "Aile Mahkemesi" },
    { id: "5", name: "Ağır Ceza Mahkemesi" },
    { id: "6", name: "Kadastro Mahkemesi" },
    { id: "7", name: "İcra Müdürlüğü" },
  ];
  const tasinmazVasiflari = [
    { id: 1, name: "Tarla" },
    { id: 2, name: "Bahçe" },
    { id: 3, name: "Ham Toprak" },
    { id: 4, name: "Arsa" },
  ];

  const [mahkemeTuru, setMahkemeTuru] = useState(".....");
  const [dosyaYili, setDosyaYili] = useState("2026");
  const [dosyaNo, setDosyaNo] = useState(".....");
  const [davaci, setDavaci] = useState("....");
  const [davali, setDavali] = useState("....");
  const [davaTarihi, setDavaTarihi] = useState("....-..-..");
  const [dosyaBilgileri, setDosyaBilgileri] = useState({
    mahkemeIl: "",
    mahkemeIlce: "",
    dosyaTuru: "",
    davaci: "",
    davali: "",
    dosyaYil: "",
    dosyaNo: "",
    davaTarihi: "",
  });
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [secilenSehir, setSehir] = useState("");
  const [secilenIlce, setIlce] = useState("");
  const [davaciAvukati, setDavaciAvukati] = useState("....");
  const [davaliAvukati, setDavaliAvukati] = useState("....");

  //taşınmaz sayfasındaki selectlere liste hazırlar
  const [tasinmazIller, setTasinmazIller] = useState([]);
  const [tasinmazIlceler, setTasinmazIlceler] = useState([]);
  const [tasinmazKoyMahalle, settasinmazKoyMahalle] = useState([]);

  //taşınmaz sayfasındaki selectlerden gelen veriyi tutar
  const [tasinmazSecilenSehir, settasinmazSecilenSehir] = useState("");
  const [tasinmazSecilenIlce, settasinmazSecilenIlce] = useState("");
  const [tasinmazSecilenKoyMahalle, settasinmazSecilenKoyMahalle] =
    useState("");

  const [davaTuru, setDavaKonusu] = useState("......");
  const [dosyaTuru, setDosyaTuru] = useState("......");
  const [adliyeSehir, setAdliyeSehir] = useState(".....");
  const [adliyeIlce, setAdliyeIlce] = useState(".......");

  const [adaNo, setAdaNo] = useState("....");
  const [parselNo, setParselNo] = useState("....");
  const [metreKare, setMetreKare] = useState(0);
  const [kamulasacakMetreKare, setKamulasacakMetreKare] = useState(0);
  const [mevkii, setMevkii] = useState("....");
  const [tasinmazVasfi, setTasinmazVasfi] = useState("....");
  const [tasinmazMalikleri, setTasinmazMalikleri] = useState(".........");
  const [malikListesi, setMalikListesi] = useState([
    { adi: "", pay: "0", payda: "0" },
  ]);

  const [tamamiKamulaştirilacak, setTamamiKamulastirilacak] = useState(false);

  //Keşifte Görülen Özellikler
  const araziYapilari = [
    { id: 1, name: "Kıraç" },
    { id: 2, name: "Taban" },
    { id: 3, name: "Sulu" },
  ];
  const toprakBunyeYapilari = [
    { id: 1, name: "Kum" },
    { id: 2, name: "Tınlı Kum" },
    { id: 3, name: "Kumlu Tın" },
    { id: 4, name: "Tın" },
    { id: 5, name: "Siltli Tın" },
    { id: 6, name: "Silt" },
    { id: 7, name: "Kumlu Killi Tın" },
    { id: 8, name: "Killi Tın" },
    { id: 9, name: "Siltli Killi Tın" },
    { id: 10, name: "Kumlu Kil" },
    { id: 11, name: "Siltli Kil" },
    { id: 12, name: "Kil" },
  ];

  const [sulamaAciklama, setSulamaAciklama] = useState("");
  const [tasinmazEgimi, setTasinmazEgimi] = useState("....");
  const [araziYapisi, setAraziYapisi] = useState("....");
  const [toprakBunyesi, settoprakBunyesi] = useState("....");
  const [koyeUzaklik, setKoyeUzaklik] = useState(".....");
  const [ilceUzaklik, setIlceUzaklik] = useState(".....");
  const [kesifAnlatim, setKesifAnlatim] = useState(false);
  const [kesifTarihi, setKesifTarihi] = useState("....-..-..");
  const [kapitalizasyonFaizOrani, setKapitalizasyonFaizOrani] = useState(0.05);

  //Dosya İncelemesi:

  const kurumlar = [
    { id: 1, name: "Büyükşehir Belediyesi Mali Hizmetler Müdürlüğü" },
    { id: 2, name: "Büyükşehir Belediyesi Fen İşleri Müdürlüğü" },
    { id: 3, name: "Büyükşehir Belediyesi Emlak ve İstimlak Müdürlüğü" },
    { id: 4, name: "Büyükşehir Belediyesi İmar ve Şehircilik Müdürlüğü" },
    { id: 5, name: "Belediyesi Mali Hizmetler Müdürlüğü" },
    { id: 6, name: "Belediyesi Fen İşleri Müdürlüğü" },
    { id: 7, name: "Belediyesi Emlak ve İstimlak Müdürlüğü" },
    { id: 8, name: "Belediyesi İmar ve Şehircilik Müdürlüğü" },
    { id: 9, name: "Valiliği Kadastro Müdürlüğü" },
    { id: 10, name: "Valiliği Tapu Müdürlüğü" },
    { id: 11, name: "Valiliği Milli Emlak Müdürlüğü" },
    { id: 12, name: "Valiliği Tarım ve Orman Müdürlüğü" },
    { id: 13, name: "Valiliği Özel İdare Müdürlüğü" },
    { id: 14, name: "Defterdarlığı" },
    { id: 15, name: "Kaymakamlığı Kadastro Müdürlüğü" },
    { id: 16, name: "Kaymakamlığı Tapu Müdürlüğü" },
    { id: 17, name: "Kaymakamlığı Milli Emlak Müdürlüğü" },
    { id: 18, name: "Kaymakamlığı Tarım ve Orman Müdürlüğü" },
    { id: 19, name: "Kaymakamlığı Özel İdare Müdürlüğü" },
    { id: 20, name: "Mal Müdürlüğü" },
    { id: 21, name: "Özel İdaresi Su Ve Kanal Hizmetleri Müdürlüğü" },
    { id: 22, name: "Özel İdaresi İmar ve Kentsel İyileştirme Müdürlüğü" },
    { id: 23, name: "DSİ Genel Müdürlüğü" },
    { id: 24, name: "DSİ Bölge Müdürlüğü" },
    { id: 25, name: "DSİ Şube Müdürlüğü" },
    { id: 26, name: "Karayolları Genel Müdürlüğü" },
    { id: 27, name: "Eti Maden İşletmeleri Genel Müdürlüğü" },
    { id: 28, name: "Devlet Demiryolları Genel Müdürlüğü" },
    { id: 29, name: "TEDAŞ Genel Müdürlüğü" },
    { id: 30, name: "TKİ Genel Müdürlüğü" },
  ];
  const [evrakList, setEvrakList] = useState([
    { kurum: "", tarih: "2026-01-01", evrakno: "", evrakinOzu: "" },
  ]);

  //DOSYADA EMLAK BEYANI VAR / YOK
  const [emlakBeyani, setEmlakBeyani] = useState(false);
  const [emlakBeyaniEvraki, setEmlakBeyaniEvraki] = useState(false);

  //DOSYADA EMLAK BEYANI VAR / YOK
  const [oncekidegerlemevarmi, setoncekidegerlemevarmi] = useState(false);
  const [oncekidegerleme, setoncekidegerleme] = useState(false);
  const [oncekidegerlemetoplamfiyat, setOncekiDegerlemeToplamFiyat] =
    useState(0);

  //Kayıtlı Münavebe
  const [munavebeler, setMunavebeler] = useState([]);

  //Değerleme Değişkenleri
  const [ortNetGelir, setOrtNetGelir] = useState(0);
  const [munUrunSayisi, setMunUrunSayisi] = useState(false);
  const [topNetGelir, setTopNetGelir] = useState(0);
  const [masrafUcteBirMi, setMasrafUcteBirMi] = useState(false);
  const [tasinmazm2fiyati, setTasinmazM2Fiyati] = useState(0);

  //Objektif Unsurlar
  const odaNedenleri = [
    { id: 1, name: "Taşınmazın il merkezine yakınlığı" },
    { id: 2, name: "Taşınmazın ilçe merkezine yakınlığı" },
    { id: 3, name: "Taşınmazın köye yakınlığı" },
    { id: 4, name: "Taşınmazın ana yola yakınlığı" },
    { id: 5, name: "Taşınmazın tali yola yakınlığı" },
    { id: 6, name: "Taşınmazın sulama şebekesine yakınlığı" },
    { id: 7, name: "Taşınmazın ürün satış yeri ve pazarlara yakınlığı" },
    { id: 8, name: "Mücavir alana olan yakınlığı" },
    { id: 9, name: "İmar alanına yakınlığı" },
    { id: 10, name: "Taşınmazın sosyal/sağlık tesislerine olan yakınlığı" },
    {
      id: 11,
      name: "Taşınmazın faydalanabileceği enerji hatlarına olan yakınlığı",
    },
    {
      id: 12,
      name: "Taşınmazın bulunduğu çevredeki yerleşim yerlerinin nüfusu",
    },
    {
      id: 13,
      name: "Taşınmazın bulunduğu çevredeki yerleşim yerlerinin tarıma olan ilgisi",
    },
    {
      id: 14,
      name: "Taşınmazın maden sahasına olan yakınlığı",
    },
  ];
  const [objektifUnsurlar, setObjektifUnsurlar] = useState([{}]);
  const [odaToplam, setOdaToplam] = useState(0);
  //OBJEKTİF DEĞER ARTIŞI GİRİŞLERİ BUNA BAĞLIDIR
  const [odaVerilecek, setOdaVerilecek] = useState(false);

  //AĞAÇ DEĞERLEME
  const agaclar = [
    { id: 1, agacAdi: "Ahududu" },
    { id: 2, agacAdi: "Antep Fıstığı" },
    { id: 3, agacAdi: "Armut" },
    { id: 4, agacAdi: "Avokado" },
    { id: 5, agacAdi: "Ayva" },
    { id: 6, agacAdi: "Badem" },
    { id: 7, agacAdi: "Böğürtlen" },
    { id: 8, agacAdi: "Ceviz" },
    { id: 9, agacAdi: "Çay" },
    { id: 10, agacAdi: "Çilek" },
    { id: 11, agacAdi: "Dut" },
    { id: 12, agacAdi: "Elma" },
    { id: 13, agacAdi: "Elma (Amasya)" },
    { id: 14, agacAdi: "Elma (Golden)" },
    { id: 15, agacAdi: "Elma (Granny Smith)" },
    { id: 16, agacAdi: "Elma (Starking)" },
    { id: 17, agacAdi: "Erik" },
    { id: 18, agacAdi: "Fındık" },
    { id: 19, agacAdi: "Greyfurt" },
    { id: 20, agacAdi: "Gül" },
    { id: 21, agacAdi: "Hünnap" },
    { id: 22, agacAdi: "İğde" },
    { id: 23, agacAdi: "İncir" },
    { id: 24, agacAdi: "Kavak" },
    { id: 25, agacAdi: "Kayısı" },
    { id: 26, agacAdi: "Keçiboynuzu" },
    { id: 27, agacAdi: "Kestane" },
    { id: 28, agacAdi: "Kızılcık" },
    { id: 29, agacAdi: "Kiraz" },
    { id: 30, agacAdi: "Kivi" },
    { id: 31, agacAdi: "Limon" },
    { id: 32, agacAdi: "Mandalina" },
    { id: 33, agacAdi: "Mandalina (King)" },
    { id: 34, agacAdi: "Mandalina (Klemantin)" },
    { id: 35, agacAdi: "Mandalina (Satsuma)" },
    { id: 36, agacAdi: "Maviyemiş" },
    { id: 37, agacAdi: "Muşmula" },
    { id: 38, agacAdi: "Muz" },
    { id: 39, agacAdi: "Nar" },
    { id: 40, agacAdi: "Nektarin" },
    { id: 41, agacAdi: "Portakal" },
    { id: 42, agacAdi: "Portakal (Washington)" },
    { id: 43, agacAdi: "Portakal (Yafa)" },
    { id: 44, agacAdi: "Sofralık Üzüm, Çekirdekli" },
    { id: 45, agacAdi: "Sofralık Üzüm, Çekirdeksiz" },
    { id: 46, agacAdi: "Şaraplık Üzüm" },
    { id: 47, agacAdi: "Şeftali" },
    { id: 48, agacAdi: "Trabzon Hurması" },
    { id: 49, agacAdi: "Turunç" },
    { id: 50, agacAdi: "Vişne" },
    { id: 51, agacAdi: "Yenidünya" },
    { id: 52, agacAdi: "Zerdali" },
    { id: 53, agacAdi: "Zeytin (Sofralık)" },
    { id: 54, agacAdi: "Zeytin (Yağlık)" },
  ];
  const [agacListesi, setAgacListesi] = useState(false);
  const [meyveVar, setMeyveVar] = useState(false);

  //değerleme parametreleri
  const [munavebeAdi, setMunavebeAdi] = useState(false);
  const [gelenListe, setGelenListe] = useState(false);
  const ormanAgaclari = [
    { id: 1, agacAdi: "Akçaağaç" },
    { id: 2, agacAdi: "Ardıç" },
    { id: 3, agacAdi: "Çam" },
    { id: 4, agacAdi: "Çınar" },
    { id: 5, agacAdi: "Dişbudak" },
    { id: 6, agacAdi: "Göknar" },
    { id: 7, agacAdi: "Gürgen" },
    { id: 8, agacAdi: "Fıstık Çamı" },
    { id: 9, agacAdi: "Huş" },
    { id: 10, agacAdi: "Ihlamur" },
    { id: 11, agacAdi: "Kavak" },
    { id: 12, agacAdi: "Kayın" },
    { id: 13, agacAdi: "Kestane" },
    { id: 14, agacAdi: "Kızılağaç" },
    { id: 15, agacAdi: "Ladin" },
    { id: 16, agacAdi: "Meşe" },
    { id: 17, agacAdi: "Sedir" },
    { id: 18, agacAdi: "Servi" },
    { id: 19, agacAdi: "Söğüt" },
  ];
  const [ormanAgacListesi, setOrmanAgacListesi] = useState(false);
  const [ormanAgaciVar, setOrmanAgaciVar] = useState(false);

  //Ürün Listesi
  const urunler = [
    "Adaçayı",
    "Adi Fiğ Dane",
    "Adi Fiğ Yeşil Ot",
    "Adi Fiğ Kuru Ot",
    "Arpa",
    "Arpa Yeşilot",
    "Aspir",
    "Ayçiçeği Çerezlik",
    "Ayçiçeği Yağlık",
    "Bezelye",
    "Biralık Arpa",
    "Börülce",
    "Buğday",
    "Buğday Yeşilot",
    "Burçak",
    "Burçak Yeşilot",
    "Çavdar",
    "Çavdar Yeşilot",
    "Çeltik",
    "Dane Mısır",
    "Hasıl Mısır",
    "Haşhaş",
    "Hayvan Pancarı",
    "Kanola",
    "Kara Buğday",
    "Keten",
    "Kırmızı Mercimek",
    "Korunga Dane",
    "Korunga Yeşil Ot",
    "Kuru Bakla",
    "Kuru Fasulye",
    "Lavanta",
    "Macar Fiğ Dane",
    "Macar Fiğ Yeşil Ot",
    "Macar Fiğ Kuru Ot",
    "Makarnalık Buğday",
    "Mürdümük",
    "Mürdümük Yeşilot",
    "Nadas",
    "Nohut",
    "Pamuk",
    "Patates",
    "Silajlık Mısır",
    "Sorgum Yeşilot",
    "Soya Fasulyesi",
    "Susam",
    "Şeker Pancarı",
    "Triticale",
    "Triticale Yeşilot",
    "Tütün",
    "Üçgül Yeşilot",
    "Yem Bezelyesi",
    "Yem Şalgamı",
    "Yerfıstığı",
    "Yeşil Mercimek",
    "Yonca K. Ot",
    "Yulaf",
    "Yulaf Yeşilot",
  ];

  const [user, setUser] = useState(false);
  const [userKredi, setUserKredi] = useState(0);
  const [isLogin, setLogin] = useState(false);
  const [userFromLogin, setUserFromLogin] = useState(false);
  const [avukatlar, setAvukatlar] = useState(false);
  const [kayitliBilirkisiler, setKayitliBilirkisiler] = useState(false);
  const [bilirkisi, setBilirkisi] = useState(false);
  const [birinciBilirkisi, setBirinciBilirkisi] = useState(false);
  const [ikinciBilirkisi, setIkinciBilirkisi] = useState(false);
  const [ucuncuBilirkisi, setUcuncuBilirkisi] = useState(false);
  const [dorduncuBilirkisi, setDorduncuBilirkisi] = useState(false);
  const [besinciBilirkisi, setBesinciBilirkisi] = useState(false);
  const [altinciBilirkisi, setAltinciBilirkisi] = useState(false);

  //RAPOR RESİMLERİ
  //konum resmi
  const [konumResim, setKonumResim] = useState("");
  //Birinci resim
  const [birinciResim, setBirinciResim] = useState("");
  //İkinci resim
  const [ikinciResim, setIkinciResim] = useState("");
  //SAYDAFAKİ ÖNİZLEME RESİMLERİ
  //konum resmi
  const [konumResmiOnizleme, setKonumResmiOnizleme] = useState("");

  //Birinci resim
  const [birinciResmiOnizleme, setBirinciResmiOnizleme] = useState("");

  //İkinci resim
  const [ikinciResmiOnizleme, setIkinciResmiOnizleme] = useState("");

  //ENH RAPORU EK PARAMETRELERİ
  const [direkAlani, setDirekAlani] = useState(0);
  const [irtifakAlani, setIrtifakAlani] = useState(0);

  //KARAYOLU RAPORU EK PARAMETRELERİ
  const [ddVarMi, setDdVarMi] = useState(false);
  const [ddOrani, setDdOrani] = useState(0);

  //ÇOK PARSELLİ RAPORU EK PARAMETRELERİ
  const [tasinmazlar, setTasinmazlar] = useState([
    {
      il: "",
      ilce: "",
      koy: "",
      ada: "",
      parsel: "",
      m2: "",
      vasif: "",
      mevkii: "",
      araziyapisi: "Taban",
      toprakyapisi: "",
      egim: "1",
      kesiftekidurumu: "",
      konumozellikleri: "",
      kullanilacakMunavebe: "",
      munavebeDetay: [],
      masrafOrani: "Resmi Veri",
      oda: "0",
      malikler: "",
      agaclar: [],
    },
  ]);

  // Resimlerin base64 olarak saklanacağı state
  const [konumlar, setKonumlar] = useState([]);
  const [r1, setR1] = useState([]);
  const [r2, setR2] = useState([]);

  const getIller = async () => {
    try {
      const response = await axios.get(
        "https://api.turkiyeapi.dev/v2/provinces",
      );

      setIller(response.data.data);
    } catch (err) {
      alert("İller alınamadı.");
    }
  };

  const getIlceler = async () => {
    try {
      if (!secilenSehir) {
        setIlceler([]);
        return;
      }

      const il = iller.find((x) => x.name === secilenSehir);

      if (!il) return;

      const response = await axios.get(
        `https://api.turkiyeapi.dev/v2/provinces/${il.id}/districts`,
      );

      setIlceler(response.data.data);
      setIlce("");
    } catch (err) {
      console.log(err);
    }
  };

  const getTasinmazIller = async () => {
    try {
      const response = await axios.get(
        "https://api.turkiyeapi.dev/v2/provinces",
      );

      setTasinmazIller(response.data.data);
    } catch (err) {
      alert("İller alınamadı.");
    }
  };

  const getTasinmazIlceler = async () => {
    try {
      if (!tasinmazSecilenSehir) {
        setTasinmazIlceler([]);
        return;
      }

      const il = tasinmazIller.find((x) => x.name === tasinmazSecilenSehir);

      if (!il) return;

      const response = await axios.get(
        `https://api.turkiyeapi.dev/v2/provinces/${il.id}/districts`,
      );

      setTasinmazIlceler(response.data.data);

      settasinmazSecilenIlce("");
      settasinmazSecilenKoyMahalle("");
      settasinmazKoyMahalle([]);
    } catch (err) {
      console.log(err);
    }
  };

  const getTasinmazKoyler = async () => {
    try {
      if (!tasinmazSecilenIlce) {
        settasinmazKoyMahalle([]);
        return;
      }

      const ilce = tasinmazIlceler.find((x) => x.name === tasinmazSecilenIlce);

      if (!ilce) return;

      // Köyler
      const villagesRes = await axios.get(
        `https://api.turkiyeapi.dev/v2/districts/${ilce.id}/villages`,
      );

      const koyler = (villagesRes.data.data || []).map((item) => ({
        ...item,
        name: `${item.name} Köyü`,
        type: "Köy",
      }));

      // Belediyeler
      const municipalitiesRes = await axios.get(
        `https://api.turkiyeapi.dev/v2/districts/${ilce.id}/municipalities`,
      );

      const belediyeler = municipalitiesRes.data.data || [];

      let mahalleler = [];

      await Promise.all(
        belediyeler.map(async (belediye) => {
          const res = await axios.get(
            `https://api.turkiyeapi.dev/v2/municipalities/${belediye.id}/neighborhoods`,
          );

          const liste = (res.data.data || []).map((item) => ({
            ...item,
            name: `${item.name} Mahallesi`,
            type: "Mahalle",
          }));

          mahalleler.push(...liste);
        }),
      );

      const tumListe = [...koyler, ...mahalleler].sort((a, b) =>
        a.name.localeCompare(b.name, "tr"),
      );

      settasinmazKoyMahalle(tumListe);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (
      window.localStorage.getItem("user") ||
      window.localStorage.getItem("isAuth") === true
    ) {
      setUser(window.localStorage.getItem("user"));
      setLogin(true);
    }
  }, [user]);

  useEffect(() => {
    getIller();
    getTasinmazIller();
  }, []);

  useEffect(() => {
    getIlceler();
  }, [secilenSehir]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getTasinmazIlceler();
  }, [tasinmazSecilenSehir]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getTasinmazKoyler();
  }, [tasinmazSecilenIlce]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <GlobalContext.Provider
      value={{
        davaTarihi,
        setDavaTarihi,
        dosyaYili,
        setDosyaYili,
        davaci,
        setDavaci,
        davali,
        setDavali,
        dosyaNo,
        setDosyaNo,
        mahkemeTuru,
        setMahkemeTuru,
        mahkemeTurleri,
        dosyaTurleri,
        dosyaTuru,
        setDosyaTuru,
        davaTuru,
        setDavaKonusu,
        davaKonuları,
        iller,
        ilceler,
        raporTurleri,
        dosyaBilgileri,
        setDosyaBilgileri,
        setSehir,
        secilenSehir,
        secilenIlce,
        setIlce,
        adliyeSehir,
        setAdliyeSehir,
        adliyeIlce,
        setAdliyeIlce,
        tasinmazIller,
        settasinmazSecilenSehir,
        tasinmazSecilenSehir,
        tasinmazIlceler,
        settasinmazSecilenIlce,
        tasinmazSecilenIlce,
        tasinmazSecilenKoyMahalle,
        settasinmazSecilenKoyMahalle,
        tasinmazKoyMahalle,

        tamamiKamulaştirilacak,
        setTamamiKamulastirilacak,

        adaNo,
        setAdaNo,
        parselNo,
        setParselNo,
        metreKare,
        setMetreKare,
        mevkii,
        setMevkii,
        tasinmazVasfi,
        setTasinmazVasfi,
        tasinmazVasiflari,
        setKamulasacakMetreKare,
        kamulasacakMetreKare,
        //MALİKLERİ TEXTAREADAN ALMAK
        tasinmazMalikleri,
        setTasinmazMalikleri,
        //MALİKLERİ LİSTEDEN ALMAK

        malikListesi,
        setMalikListesi,
        //
        araziYapilari,
        toprakBunyeYapilari,
        tasinmazEgimi,
        setTasinmazEgimi,
        araziYapisi,
        setAraziYapisi,
        toprakBunyesi,
        settoprakBunyesi,
        sulamaAciklama,
        setSulamaAciklama,
        koyeUzaklik,
        setKoyeUzaklik,
        ilceUzaklik,
        setIlceUzaklik,
        kesifAnlatim,
        setKesifAnlatim,
        kesifTarihi,
        setKesifTarihi,
        setKapitalizasyonFaizOrani,
        kapitalizasyonFaizOrani,
        kurumlar,
        evrakList,
        setEvrakList,
        urunler,
        munavebeler,
        setMunavebeler,
        setOrtNetGelir,
        munUrunSayisi,
        setMunUrunSayisi,
        setTopNetGelir,
        topNetGelir,
        ortNetGelir,
        masrafUcteBirMi,
        setMasrafUcteBirMi,
        objektifUnsurlar,
        setObjektifUnsurlar,
        odaNedenleri,
        odaToplam,
        setOdaToplam,
        odaVerilecek,
        setOdaVerilecek,
        agaclar,
        agacListesi,
        setAgacListesi,
        meyveVar,
        setMeyveVar,
        ormanAgaclari,
        ormanAgacListesi,
        setOrmanAgacListesi,
        ormanAgaciVar,
        setOrmanAgaciVar,
        user,
        setUser,
        userKredi,
        setUserKredi,
        isLogin,
        setLogin,
        userFromLogin,
        setUserFromLogin,
        emlakBeyani,
        setEmlakBeyani,
        emlakBeyaniEvraki,
        setEmlakBeyaniEvraki,
        oncekidegerlemevarmi,
        setoncekidegerlemevarmi,
        oncekidegerleme,
        setoncekidegerleme,
        oncekidegerlemetoplamfiyat,
        setOncekiDegerlemeToplamFiyat,

        //deĞERLEME PARAMETRELERİ
        tasinmazm2fiyati,
        setTasinmazM2Fiyati,
        munavebeAdi,
        setMunavebeAdi,
        gelenListe,
        setGelenListe,
        avukatlar,
        setAvukatlar,
        davaciAvukati,
        setDavaciAvukati,
        davaliAvukati,
        setDavaliAvukati,
        kayitliBilirkisiler,
        setKayitliBilirkisiler,
        birinciBilirkisi,
        setBirinciBilirkisi,
        ikinciBilirkisi,
        setIkinciBilirkisi,
        ucuncuBilirkisi,
        setUcuncuBilirkisi,
        dorduncuBilirkisi,
        setDorduncuBilirkisi,
        besinciBilirkisi,
        setBesinciBilirkisi,
        altinciBilirkisi,
        setAltinciBilirkisi,
        bilirkisi,
        setBilirkisi,

        //RESİMLER
        konumResim,
        setKonumResim,
        birinciResim,
        setBirinciResim,
        ikinciResim,
        setIkinciResim,
        //ÖNİZLEME RESİMLER
        konumResmiOnizleme,
        setKonumResmiOnizleme,
        birinciResmiOnizleme,
        setBirinciResmiOnizleme,
        ikinciResmiOnizleme,
        setIkinciResmiOnizleme,
        //ENH PARAMETRELERİ
        direkAlani,
        setDirekAlani,
        irtifakAlani,
        setIrtifakAlani,
        ddVarMi,
        setDdVarMi,
        ddOrani,
        setDdOrani,
        //ÇOK PARSELLİ RAPOR
        tasinmazlar,
        setTasinmazlar,
        konumlar,
        setKonumlar,
        r1,
        setR1,
        r2,
        setR2,
        API_URL,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};
